import { FormControl, ValidatorFn } from "@angular/forms";

export const convertToInteger = (control: FormControl) => {
    const x = control.value;

    if(!control.value && control.value!==-0)
        return null;

    if(typeof x == 'number' && !isNaN(x)){
        // check if it is integer
        if (!Number.isInteger(x)) {
            control.patchValue(Math.floor(control.value), {onlySelf:true, emitEvent:false });
        }
    }

  return null;
};

